import { ArrowDropDownCircleOutlined } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ColorModeContext, tokens } from "../../theme";
import { authFetch } from "../../Utils/apiClient";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState({
    name: "",
    image: "",
  });
  const [anchorEl, setAnchorEl] = React.useState(null);

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const adminId = localStorage.getItem("adminId");
        const response = await authFetch(`/admin/getAdminById/${adminId}`);
        const data = await response.json();
        if (data?.id) {
          setAdminData(data);
        }
      } catch (error) {
        console.error("Error fetching admin data:", error);
      }
    };

    fetchAdminData();
  }, []);

  const logoSrc =
    theme.palette.mode === "dark"
      ? "../../assets/logo2.png"
      : "../../assets/logo.png";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);

    const style = document.createElement('style');
    style.innerHTML = `
      .swal2-confirm {
        background-color: ${colors.redAccent[500]} !important;
        color: white !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 10px 24px !important;
        font-size: 1rem !important;
        font-weight: 600 !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        transition: all 0.3s ease !important;
        margin-right: 16px !important;
      }
      .swal2-confirm:hover {
        background-color: ${colors.redAccent[600]} !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15) !important;
      }
      .swal2-confirm:active {
        transform: translateY(0) !important;
      }
      .swal2-cancel {
        background-color: ${colors.blueAccent[500]} !important;
        color: white !important;
        border: none !important;
        border-radius: 8px !important;
        padding: 10px 24px !important;
        font-size: 1rem !important;
        font-weight: 600 !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        transition: all 0.3s ease !important;
      }
      .swal2-cancel:hover {
        background-color: ${colors.blueAccent[600]} !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15) !important;
      }
      .swal2-cancel:active {
        transform: translateY(0) !important;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .swal2-popup-custom {
        border-radius: 12px !important;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2) !important;
        background: ${colors.primary[500]} !important;
      }
      .swal2-header-custom {
        padding-bottom: 1rem !important;
      }
      .swal2-actions-custom {
        margin-top: 1.5rem !important;
      }
      .swal2-title-custom {
        margin-bottom: 0.5rem !important;
        color: ${colors.grey[100]} !important;
      }
    `;
    document.head.appendChild(style);

    Swal.fire({
      title: `<strong style="font-size: 1.5rem; color: ${colors.grey[100]}">Logout Confirmation</strong>`,
      html: `
        <div style="text-align: center; color: ${colors.grey[100]}">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15.5V12.5M12 12.5V9.5M12 12.5H15M12 12.5H9" stroke="${colors.redAccent[500]}" stroke-width="2" stroke-linecap="round"/>
            <path d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7" stroke="${colors.redAccent[500]}" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <p style="font-size: 1.1rem; margin-top: 1rem; color: ${colors.grey[100]}">Are you sure you want to logout?</p>
          <p style="color: ${colors.grey[300]}; margin-top: 0.5rem;">You'll need to login again to access your account</p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Logout',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      buttonsStyling: false,
      showClass: {
        popup: 'animate__animated animate__fadeIn animate__faster'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOut animate__faster'
      },
      background: colors.primary[500],
      width: '450px',
      padding: '2rem',
      customClass: {
        popup: 'swal2-popup-custom',
        header: 'swal2-header-custom',
        title: 'swal2-title-custom',
        actions: 'swal2-actions-custom'
      }
    }).then((result) => {
      document.head.removeChild(style);
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Logging out...',
          html: `
            <div style="display: flex; flex-direction: column; align-items: center;">
              <div class="loader" style="border: 4px solid ${colors.primary[400]}; border-radius: 50%; border-top: 4px solid ${colors.greenAccent[500]}; width: 40px; height: 40px; animation: spin 1s linear infinite; margin-bottom: 16px;"></div>
              <p style="color: ${colors.grey[100]}">Please wait while we securely log you out</p>
            </div>
          `,
          background: colors.primary[500],
          showConfirmButton: false,
          timer: 1500,
          willClose: () => {
            localStorage.clear();
            navigate("/");
          }
        });
      }
    });
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor={colors.primary[400]}
      p={2}
    >
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="50%"
        overflow="hidden"
        width="100px"
        height="100px"
      >
        <img
          alt="profile-user"
          src={logoSrc}
          style={{
            width: "100%",
            height: "100%",
            cursor: "pointer",
            borderRadius: "50%",
            transform:
              theme.palette.mode === "dark" ? "scale(1.2)" : "scale(1)",
            transition: "transform 0.3s ease",
          }}
        />
      </Box>

      <Box>
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon style={{ fontSize: "1.8rem" }} />
          ) : (
            <LightModeOutlinedIcon style={{ fontSize: "1.8rem" }} />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon style={{ fontSize: "1.8rem" }} />
        </IconButton>

        <IconButton
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginRight="20px"
        >
          <img
            alt="profile-user"
            width="50px"
            height="50px"
            src={adminData.image}
            style={{ cursor: "pointer", borderRadius: "50%" }}
          />
          <Typography
            sx={{ display: "flex", flexDirection: "column", m: "10px" }}
            onClick={handleClick}
          >
            <Typography
              variant="h4"
              color={colors.grey[100]}
              fontWeight="bold"
              sx={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              {adminData.name} <ArrowDropDownCircleOutlined />
            </Typography>
            <Typography variant="h5" color={colors.greenAccent[500]}>
              Admin
            </Typography>
          </Typography>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem
              component={Link}
              to="/profile"
              onClick={handleClose}
              style={{ fontSize: "larger" }}
            >
              <IconButton>
                <AccountCircleIcon />
              </IconButton>
              My Profile
            </MenuItem>
            <MenuItem
              onClick={handleLogout}
              style={{
                fontSize: "larger",
                color: colors.redAccent[500]
              }}
            >
              <IconButton>
                <ExitToAppIcon style={{ color: colors.redAccent[500] }} />
              </IconButton>
              Logout
            </MenuItem>
          </Menu>
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;